import store from '../store'
export function hasPermission(permission) {
    const myPermission = store.getters.permission
    return myPermission.indexOf(permission) >-1
}